module.exports = __webpack_public_path__ + "img/277.aa34b064.png";